import { FC } from 'react';
import ProAnchor, { AnchorProps } from './anchor';
import ProAnchorLink, { AnchorLinkProps } from './link';

export type IAnchorComponent = FC<
  AnchorProps & React.RefAttributes<HTMLElement>
> & {
  Link: FC<AnchorLinkProps & React.RefAttributes<HTMLElement>>;
};

const TransAnchor = ProAnchor as IAnchorComponent;
TransAnchor.Link = ProAnchorLink;

export default TransAnchor;
